import { call, put } from '@redux-saga/core/effects';
import { api, notify, formDataBuilder, apiErrorHandler } from 'services';
import {
  UpdateDeliveryVoucherActions as Actions,
  UpdateDeliveryVoucherRequestAction as RequestAction,
} from 'store/ducks/deliveryVouchers';

export function* updateDeliveryVoucherRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    const formData = formDataBuilder(putData);
    yield call(api.put, `delivery-vouchers/${id}`, formData) || { data: null};
    onSuccess && onSuccess();
    notify('success', 'Canhoto atualizado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
